import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const DEVICE_ID_KEY = 'fuga_device_id';

function getOrCreateDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}

/**
 * HeadersInterceptor — añade cabeceras de trazabilidad a todas las peticiones (doc FGA-7 §D):
 *   - X-Request-Id: UUID único por request (trazabilidad en logs del backend).
 *   - X-Device-Id:  ID persistente por dispositivo (detección de nuevo dispositivo en auth).
 */
@Injectable({ providedIn: 'root' })
export class HeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const enriched = req.clone({
      setHeaders: {
        'X-Request-Id': crypto.randomUUID(),
        'X-Device-Id': getOrCreateDeviceId(),
      },
    });
    return next.handle(enriched);
  }
}
